import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ChatMarkdownComponent } from '../chat-markdown/chat-markdown';

@Component({
  selector: 'pm-chat-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (role() === 'user') {
      <div
        class="ml-auto max-w-[320px] whitespace-pre-wrap rounded-lg bg-surface-neutral-subdued p-3 text-sm font-normal leading-[1.3] text-content-default [overflow-wrap:anywhere]"
      >
        {{ text() }}
      </div>
    } @else if (role() === 'assistant' && text()) {
      <div class="w-full">
        <pm-chat-markdown [text]="text()" />
      </div>
    }
  `,
  imports: [ChatMarkdownComponent],
})
export class ChatMessageComponent {
  readonly role = input.required<
    | 'user'
    | 'assistant'
    | 'developer'
    | 'system'
    | 'tool'
    | 'activity'
    | 'reasoning'
  >();
  readonly text = input.required<string>();
}
